import ajax from "../helpers/ajax";
import StoreContainer from "../stores/StoreContainer";

class NetsuiteOrderService {
  static async lookup(
    siteId: number,
    email: string,
    zipcode: string,
    ordernumber: string
  ): Promise<any> {
    var data = ordernumber ? { ordernumber } : { email, zipcode };
    var result = await ajax({
      url: `${StoreContainer.SettingStore.getMainApiEndpoint()}/v1/${siteId}/Netsuite/LookupSalesOrder`,
      data
    });

    var results = [];

    try {
      results = JSON.parse(result);
    } catch (ex) {
      results = result;
    }
    var uniqueRecords: any[] = [];

    results.forEach((item: any) => {
      uniqueRecords = uniqueRecords.filter((x: any) => x.id !== item.id);
      uniqueRecords.push(item);
    });

    return uniqueRecords;
  }

  static async getOrder(siteId: number, id: string): Promise<any> {
    var result = await ajax({
      url: `${StoreContainer.SettingStore.getMainApiEndpoint()}/v1/${siteId}/Netsuite/GetSalesOrder`,
      data: { id }
    });

    return JSON.parse(result);
  }
}

export default NetsuiteOrderService;
